import { onInvalidToken } from 'mobile/common-functions';
import { useNavigate } from 'react-router-dom';
import { ErrorDto } from 'services/dtos/errors-dto';

export interface ErrorHandlerOptions {
    // Las pantallas que muestran la falta de red dentro de su propia UI (banner
    // inline, stage propio) pasan false. Sin esto la navegación las desmonta
    // antes de que ese estado llegue a pintarse: es lo que dejaba inalcanzable
    // el manejo inline que ya existía en las pantallas de pases.
    navigateOnNetworkError?: boolean;
}

export const useErrorHandler = ({ navigateOnNetworkError = true }: ErrorHandlerOptions = {}) => {
    const navigate = useNavigate();
    const errorHandler = (err: any) => {
        if (err.code == 'ERR_NETWORK') {
            if (navigateOnNetworkError) navigate('/mobile/offline');
            return;
        }
        if (err.code == 'ERR_BAD_RESPONSE') navigate('/mobile/500');
        const error = err as ErrorDto;

        if (err.code == 'ERR_BAD_REQUEST') {
            if (error.response.data.code == 401) {
                onInvalidToken({ v: 1, data: {} });
            }
            error.response.data.code == 433 && navigate('/mobile/invalid-session');
            error.response.data.code == 434 && navigate('/mobile/invalid-session');
            err.response.data.status == 404 && navigate('/mobile/500');
            err.response.data.status == 400 && navigate('/mobile/500');
        }
    };
    return errorHandler;
};
